import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import { ServiceProductItem, ServiceProductDetail } from 'model/modules/services/serviceProductItem';
import {
  ApiFetchServiceProductListResponse,
  ApiFetchServiceProductDetailResponse,
} from 'rtkQuery/sharespro/types/services/serviceProductItem';
import {
  mapServiceProductListFromApi,
  mapServiceProductDetailFromApi,
} from 'rtkQuery/sharespro/mapper/modules/services/mapServiceProductFromApi';

export const servicesApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchDefaultServiceList: builder.query<
      SharesproApiResponse<ApiDefaultServiceListResponseData>,
      void
    >({
      query: () => ({
        url: '/v3/service/default/list',
        method: 'GET',
        sendToken: true,
      }),
    }),
    fetchDefaultServiceDetail: builder.query<
      SharesproApiResponse<ApiDefaultServiceDetailResponseData>,
      number
    >({
      query: (id) => ({
        url: '/v3/service/default/detail',
        method: 'GET',
        params: { id },
        sendToken: true,
      }),
    }),
    fetchServiceProductList: builder.query<ServiceProductItem[], void>({
      query: () => ({
        url: '/v3/service/product/list',
        method: 'GET',
        sendToken: true,
      }),
      transformResponse: (
        response: SharesproApiResponse<ApiFetchServiceProductListResponse>
      ) => mapServiceProductListFromApi(response.data.items),
    }),
    fetchServiceProductDetail: builder.query<ServiceProductDetail, number>({
      query: (id) => ({
        url: '/v3/service/product/detail',
        method: 'GET',
        params: { id },
        sendToken: true,
      }),
      transformResponse: (
        response: SharesproApiResponse<ApiFetchServiceProductDetailResponse>
      ) => mapServiceProductDetailFromApi(response.data.item),
    }),
    requestServiceProduct: builder.mutation<SharesproApiResponse<boolean>, number>({
      query: (id) => ({
        url: '/v3/service/product/request',
        method: 'POST',
        params: { id },
        sendToken: true,
      }),
    }),
    stopInvestorService: builder.mutation<boolean, number>({
      query: (productId) => ({
        url: '/v3/client/investor-service/stop',
        method: 'POST',
        params: { product_id: productId },
        sendToken: true,
      }),
      transformResponse(baseQueryReturnValue: boolean) {
        return baseQueryReturnValue;
      },
    }),
    resumeInvestorService: builder.mutation<boolean, number>({
      query: (productId) => ({
        url: '/v3/client/investor-service/resume',
        method: 'POST',
        params: { product_id: productId },
        sendToken: true,
      }),
      transformResponse(baseQueryReturnValue: boolean) {
        return baseQueryReturnValue;
      },
    }),
    requestManagerCall: builder.mutation<SharesproApiResponse<boolean>, ID>({
      query: (id) => ({
        url: '/v3/service/order/lead',
        method: 'POST',
        sendToken: true,
        body: { service: id },
      }),
    }),
  }),
});

export const {
  useFetchDefaultServiceListQuery,
  useFetchDefaultServiceDetailQuery,
  useRequestManagerCallMutation,
  useFetchServiceProductListQuery,
  useFetchServiceProductDetailQuery,
  useRequestServiceProductMutation,
  useStopInvestorServiceMutation,
  useResumeInvestorServiceMutation,
} = servicesApi;
